import { z } from "zod";
import { PaginatedSearchSchema } from "./paginated-search";

const OrderFiltersSchema = z
  .object({
    id: z.string().optional(),
    customer: z.string().optional(),
    patient: z.string().optional(),
    start_date: z.string().optional(),
    end_date: z.string().optional(),
    lab: z.string().optional(),
    status: z.string().optional(),
    internal_ref: z.string().optional(),
    product: z.string().optional(),
    ratio: z.string().optional(),
    teeth: z.string().optional(),
    gamme: z.string().optional(),
    prothesist: z.string().optional(),
    techniciens: z.string().optional(),
    taches: z.string().optional(),
    approx: z.string().optional(),
    cpte_maitre: z.string().optional(),
    logicalor: z.string().optional(),
    empreinte_optique: z.string().optional(),
    is_ordonnancement: z.string().optional(),
    market: z.string().optional(),
  })
  .optional()
  .default({});

export const OrderSearchSchema = PaginatedSearchSchema.extend({
  searched: z.boolean().optional().default(false),
  orderFilters: OrderFiltersSchema,
  sort: z
    .enum([
      "code.asc",
      "code.desc",
      "creationDate.asc",
      "creationDate.desc",
      "submissionDate.asc",
      "submissionDate.desc",
      "deliveryDate.asc",
      "deliveryDate.desc",
      "patient.asc",
      "patient.desc",
      "price.asc",
      "price.desc",
      "customerLastname.asc",
      "customerLastname.desc",
      "computedStatus.asc",
      "computedStatus.desc",
      "ratio.asc",
      "ratio.desc",
    ])
    .optional(),
});
